import moment from 'moment';
import yn from '../../../Utils/ynToBool';
import { getFormattedValidationErrorFromAction } from 'Utils/getFormattedValidationErrorFromAction';
import { get } from 'lodash';
import { getFirstParticipantPhone } from 'Utils/getFirstParticipantPhone';

const initialState = {
  isLoading: true,
  requestMake: false,
  finishRequests: false,
  isError: false,
};

const selectParticipantPhones = (
  phones,
  options = {
    readOnlyPhoneFront: false,
    readOnlyWorkPhoneFront: false,
  }
) => {
  const defaultPhones = {
    home: { areaCode: '', number: '', type: 'HOME' },
    mobile: { areaCode: '', number: '', type: 'MOBILE' },
    work: { areaCode: '', number: '', type: 'WORK' },
  };
  if (!phones || phones.length === 0) return defaultPhones;

  const home = 'HOME';
  const mobile = 'MOBILE';
  const work = 'WORK';
  const matchPhone = (prev, { areaCode, number, type }) => {
    const isDisabledPhoneHome = get(options, `readOnlyPhoneFront`, true);
    const isDisabledPhoneWork = get(options, `readOnlyWorkPhoneFront`, true);
    const isDisabledPhoneMobile = get(options, `readOnlyPhoneFront`, true);
    switch (type) {
      case home:
        return {
          ...prev,
          home: {
            areaCode,
            number,
            disabled: isDisabledPhoneHome,
            type,
          },
        };
      case mobile:
        return {
          ...prev,
          mobile: {
            areaCode,
            number,
            disabled: isDisabledPhoneMobile,
            type,
          },
        };
      case work:
        return {
          ...prev,
          work: {
            areaCode,
            number,
            disabled: isDisabledPhoneWork,
            type,
          },
        };
      default:
        return { ...prev };
    }
  };

  return phones.reduce(matchPhone, defaultPhones);
};


export const FETCH_PARTICIPANT = 'FETCH_PARTICIPANT';
export const FETCH_PARTICIPANT_SUCCESS = `${FETCH_PARTICIPANT}_SUCCESS`;
export const FETCH_PARTICIPANT_FAIL = `${FETCH_PARTICIPANT}_FAIL`;
export const UPDATE_PARTICIPANT = 'UPDATE_PARTICIPANT';
export const UPDATE_PARTICIPANT_BLOCK_REDIRECT = `${UPDATE_PARTICIPANT}_UPDATE_PARTICIPANT`;
export const UPDATE_PARTICIPANT_INVALID = `${UPDATE_PARTICIPANT}_INVALID`;
export const UPDATE_PARTICIPANT_ADDRESS_INVALID = `${UPDATE_PARTICIPANT}_ADDRESS_INVALID`;
export const UPDATE_PARTICIPANT_SUCCESS = `${UPDATE_PARTICIPANT}_SUCCESS`;
export const UPDATE_PARTICIPANT_FAIL = `${UPDATE_PARTICIPANT}_FAIL`;
export const EXIPIRE_UPDATED_PARTICIPANT = 'EXIPIRE_UPDATED_PARTICIPANT';
export const CLEAN_ERROR_PARTICIPANT = 'CLEAN_ERROR_PARTICIPANT';

/* eslint-disable */
const ParticipantsReducer = (
  state = initialState,
  action = {
    payload: {
      data: {},
    },
  }
) => {
  switch (action.type) {
    case FETCH_PARTICIPANT:
      return {
        ...state,
        isLoading: true,
        requestMake: true,
        finishRequests: false,
        isError: false,
      };
    case FETCH_PARTICIPANT_SUCCESS:
      const participant = (action.payload || { data: {} }).data;

      const {
        catalogParameters,
        address,
        documentNumber,
        ie,
        emails,
        persontypeId,
        genderTypeId,
        birthDate,
        maritalStatusId,
        profileId,
        statusId,
        companyName,
        name,
        clientId,
        catalogId,
        partnerCpf,
        rg,
      } = participant;
      let phones;
      if (participant.phones)
        phones = selectParticipantPhones(participant.phones, catalogParameters);

      let catalogParameterEmail = get(
        catalogParameters,
        'readOnlyEmailFront',
        true
      );

      let catalogParameterCpf = get(
        catalogParameters,
        'readOnlyCpfFront',
        true
      );

      return {
        ...state,
        isLoading: false,
        requestMake: false,
        finishRequests: true,
        isError: false,
        personType: persontypeId,
        isCompany: persontypeId === 2,
        profileId,
        statusId,
        rg,

        unmergedCartVoucher: false,
        genderType: {
          value: genderTypeId,
          disabled: yn(catalogParameters.readOnlyGenderTypeFront),
        },
        birthDate: {
          value: birthDate ? moment.utc(birthDate).format('DD/MM/YYYY') : '',
          disabled: yn(catalogParameters.readOnlyBirthDateFront) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_BIRTHDATE),
        },

        customBirthDate: {
          value: birthDate || '',
          disabled: yn(catalogParameters.readOnlyBirthDateFront) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_BIRTHDATE),
        },

        maritalStatus: {
          value: maritalStatusId,
          disabled: yn(catalogParameters.readOnlyMaritalStatusFront),
        },
        name: {
          value: name,
          disabled: yn(catalogParameters.readOnlyNameFront) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_NAME),
        },
        companyName: {
          value: companyName == null ? name : companyName,
          disabled: yn(catalogParameters.readOnlyCompanyNameFront),
        },
        cpf: {
          value: documentNumber,
          disabled: yn(catalogParameterCpf),
        },
        cnpj: {
          value: documentNumber,
          disabled: yn(catalogParameterCpf),
        },

        cpfCnpj: {
          value: documentNumber,
          disabled: yn(catalogParameterCpf),
        },
        partnerCpf: {
          value: partnerCpf,
          disabled: yn(catalogParameters.readOnlyPartnerCpfFront),
        },
        ie: {
          value: ie,
          disabled: yn(catalogParameters.readIEFront),
        },
        mails: {
          value: emails,
          disabled: catalogParameterEmail,
        },
        email: {
          value: emails.length > 0 ? emails[0].email : '',
          disabled: catalogParameterEmail,
        },
        // Objeto criado com objetivo de manter o telefone anterior, pois deve ser inalteravel
        // ============
        emailsDefault: emails,
        phonesDefault: participant.phones,
        // ============
        phone: getFirstParticipantPhone(phones),
        address: address
          ? {
            addressText: {
              value: address.street,
              disabled: yn(catalogParameters.shippingAddessFront) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            number: {
              value: address.number,
              disabled: yn(catalogParameters.shippingAddessNumber) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            complement: {
              value: address.complement,
              disabled: (yn(catalogParameters.shippingAddessComplementFront || catalogParameters.shippingAddessComplement) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)),
            },
            district: {
              value: address.district,
              disabled: yn(catalogParameters.shippingAddessDistrictFront) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            city: {
              value: address.city,
              disabled: yn(catalogParameters.shippingAddessCityFront) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            state: {
              value: address.state,
              disabled: yn(catalogParameters.shippingAddessStateFront) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            zipCode: {
              value: address.zipCode,
              disabled: yn(catalogParameters.shippingZipCodeFront || catalogParameters.shippingZipCode) || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            reference: {
              value: address.reference,
              disabled: 'false' || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
          }
          : {
            addressText: {
              value: '',
              disabled: catalogParameters.shippingAddessFront || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            number: {
              value: '',
              disabled: catalogParameters.shippingAddessNumberFront || catalogParameters.shippingAddessNumber || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            complement: {
              value: '',
              disabled: catalogParameters.shippingAddessComplementFront || catalogParameters.shippingAddessComplement || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            district: {
              value: '',
              disabled: catalogParameters.shippingAddessDistrictFront || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            city: {
              value: '',
              disabled: catalogParameters.shippingAddessCityFront || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            state: {
              value: '',
              disabled: catalogParameters.shippingAddessStateFront || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            zipCode: {
              value: '',
              disabled: catalogParameters.shippingZipCodeFront || catalogParameters.shippingZipCode || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
            reference: {
              value: '',
              disabled: 'false' || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS),
            },
          },
          
        phones,
        clientId,
        catalogId,
        catalogParameters,
      };
    case FETCH_PARTICIPANT_FAIL:
      return {
        ...state,
        isLoading: false,
        requestMake: false,
        finishRequests: false,
        isError: true,
      };
    case UPDATE_PARTICIPANT:
      return { ...state, isUpdating: true, updatedSuccessfully: false };
    case UPDATE_PARTICIPANT_BLOCK_REDIRECT:
      return {
        ...state,
        onlyCashOrPointsBlockRedirect: action.onlyCashOrPointsBlockRedirect,
      };
    case UPDATE_PARTICIPANT_INVALID:
      return {
        ...state,
        invalidParticipant: action.invalidParticipant,
      };
    case UPDATE_PARTICIPANT_ADDRESS_INVALID:
      return {
        ...state,
        invalidAddress: action.invalidAddress,
      };
    case UPDATE_PARTICIPANT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        hasError: false,
        updatedSuccessfully: true,
      };
    case UPDATE_PARTICIPANT_FAIL:
      const errorUpdateParticipant =
        getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isUpdating: false,
        updatedSuccessfully: false,
        hasError: true,
        error: errorUpdateParticipant,
      };
    case EXIPIRE_UPDATED_PARTICIPANT:
      return {
        ...state,
        updatedSuccessfully: false,
      };
    case CLEAN_ERROR_PARTICIPANT:
      return {
        ...state,
        hasError: false,
      };
    default:
      return state;
  }
};

export default ParticipantsReducer;
